export const isValidArray = (data: unknown): boolean =>
  Array.isArray(data) && data.length > 0;

export const isValidObject = (data: unknown): boolean =>
  !!data && typeof data === 'object' && Object.keys(data).length > 0;

export const canParseJson = (jsonString: unknown): boolean => {
  if (typeof jsonString === 'object') return false;

  try {
    const o = JSON.parse(jsonString as string);

    if (o && typeof o === 'object') {
      return true;
    }
  } catch {
    return false;
  }

  return false;
};

export const tryParse = (jsonString: unknown): any => {
  if (typeof jsonString === 'object') return false;

  try {
    const o = JSON.parse(jsonString as string);

    if (o && typeof o === 'object') {
      return o;
    }
  } catch {
    return {};
  }

  return false;
};
